import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    MotorsDraftState,
    DRAFT_MOTORS_FEATURE_KEY
} from './motors.draft.reducer';

export const getDraftStateMotors = createFeatureSelector<
MotorsDraftState
>(DRAFT_MOTORS_FEATURE_KEY);

export const getStateMotors = createSelector(
    getDraftStateMotors,
    (state: MotorsDraftState) => state
);

export const getValidationSchemaMotors = createSelector(
    getDraftStateMotors,
    (state: MotorsDraftState) => {
        return state.validationSchema;
    }
);

export const getValidationResultsMotors = createSelector(
    getDraftStateMotors,
    (state: MotorsDraftState) => {
        return state.validationResults;
    }
);

export const validateListingResponseMotors = createSelector(
    getDraftStateMotors,
    (state: MotorsDraftState) => {
        return state.validateListingResponse;
    }
);

export const getDraftLoadedMotors = createSelector(
    getDraftStateMotors,
    (state: MotorsDraftState) => state.draftLoaded
);

export const getDraftDataMotors = createSelector(
    getDraftStateMotors,
    (state: MotorsDraftState) => state.draftData
);

export const getListingActionResponseMotors = createSelector(
    getDraftStateMotors,
  (state: MotorsDraftState) => state.makeListingActionResponse
);

export const getListingActionLoadingMotors = createSelector(
    getDraftStateMotors,
  (state: MotorsDraftState) => state.makeListingActionLoading
);
